<template lang="pug">
#TheFooter
    .container.p-5
  
        .column
          .flex-imgs
            img(src="@/assets/logo.png", style="height: 50px")
            b-tooltip(label="Ir a az.cl", position="is-top")
              a(href="https://www.az.cl", target="_blank")
                img(src="@/assets/az.png", style="height: 50px")
            b-tooltip(label="Ir a ceptinel.cl", position="is-top")
              a(href="https://www.ceptinel.com", target="_blank")
                img(src="@/assets/imagotipo.png", style="height: 50px")
</template>
<script>
export default {
  name: "TheFooter",
};
</script>
<style>
.flex-imgs {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  gap: 1rem;
}
.flex-imgs > * {
  flex-grow: 1;
}
.flex-imgs img {
  object-fit: contain;
}
</style>
